/**
 * Support Module Barrel Export
 *
 * Central export point for all module-specific support registries.
 * Each module file contains support content (hints, explanations, visuals)
 * for families within that module.
 *
 * Usage:
 *   import { STU_SUPPORT, TOPO_SUPPORT } from './modules'
 *
 * S-5 (Support RC audit 2026): removed re-exports of unused `*_SUPPORT_STATS`
 * objects. They were exported from every module file but had no consumers.
 * The aggregator in `familySupportRegistry.ts` is the single source of truth
 * for runtime stats via `validateHintCoverage()` / `generateSupportCoverageReport()`.
 */

export { STU_SUPPORT } from './stu.support'
export { TOPO_SUPPORT } from './topo.support'
export { REK_SUPPORT } from './rek.support'
export { SPR_SUPPORT } from './spr.support'
export { SWW_SUPPORT } from './sww.support'
export { TAA_SUPPORT } from './taa.support'
export { MET_SUPPORT } from './met.support'
export { TIJD_SUPPORT } from './tijd.support'
export { GELD_SUPPORT } from './geld.support'
export { GET_SUPPORT } from './get.support'
